import { useLocation, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { Button } from "@/components/ui";

const MODES = [
  { path: "/deliveries", label: "Liste", exact: true },
  { path: "/deliveries/by-zone", label: "Par Zone", exact: true },
  { path: "/deliveries/by-driver", label: "Par Livreur", exact: true },
] as const;

function isActive(pathname: string, path: string, exact: boolean): boolean {
  if (exact) return pathname === path;
  return pathname === path || pathname.startsWith(`${path}/`);
}

/**
 * Commutateur de mode pour les écrans Livraisons.
 * Liste | Par Zone | Par Livreur. Préserve les paramètres de filtres (query string) au changement de mode.
 */
export function DeliveriesModeSwitch(): JSX.Element {
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname;

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0,
        borderRadius: 2,
        border: 1,
        borderColor: "divider",
        p: 0.25,
        bgcolor: "background.default",
      }}
    >
      {MODES.map(({ path, label, exact }) => {
        const active = isActive(pathname, path, exact);
        return (
          <Button
            key={path}
            variant={active ? "primary" : "text"}
            size="small"
            onClick={() => navigate(path + location.search)}
            sx={{
              minWidth: "auto",
              px: 2,
              borderRadius: 1.5,
              ...(active && { boxShadow: 1 }),
            }}
          >
            {label}
          </Button>
        );
      })}
    </Box>
  );
}
